import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  headerData: {
    SearchText: '',
    locationId:'',
    distance:0
  },
  userNotifyList: null,
  searchText:"",
  currentLocation:"",
  distance:"",
  locationMasterList:[],
  locationDistanceList:[]
};

export const headerInfoSlice = createSlice({
  name: 'headerInfo',
  initialState,
  reducers: {
    setGlopalSearch: (state, action) => {
      state.headerData.SearchText = action.payload?.search;
      state.headerData.locationId = action.payload?.locationValue;
      state.headerData.distance = action.payload?.defaultDistance;
    },
    resetGlopalSearch: (state, action) => {
      state.headerData.SearchText = '';
      state.headerData.locationId = '';
      state.headerData.distance = initialState.headerData.distance;
    },
    userNotifyList: (state, action) => {
      state.userNotifyList = action.payload;
    },
    setSearchText:(state,action) => {
      state.searchText = action.payload
    },
    setCurrentLocation:(state,action) => {
      state.currentLocation = action.payload
    },
    resetHeaderSearch:(state,action) => {
      state.currentLocation = initialState.currentLocation;
      state.searchText = initialState.searchText
      state.distance = initialState.distance
    },
    setHeaderState:(state,{payload}) => {
      state[payload?.name] = payload?.value
    }
  },
});

export const { setGlopalSearch, resetGlopalSearch, userNotifyList,setSearchText,setCurrentLocation ,resetHeaderSearch,setHeaderState} =
  headerInfoSlice.actions;
export default headerInfoSlice.reducer;
